import { WarningIcon } from '@/common/icons/support.tsx'
import { ChildrenProp } from '@/common/types_and_interfaces.ts'

export default function AlertWithAccent({ children }: ChildrenProp) {
  return (
    <div className="border-l-4 border-yellow-400 bg-yellow-100 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <WarningIcon className="text-yellow-400" />
        </div>
        <div className="ml-3">{children}</div>
      </div>
    </div>
  )
}
